import Timer from "@/domain/metrics/timer";
import Message from "./message";

export default class Gallery {

    static albumId = null
    static _cache = {
        media: {},
        banner: {},
        view: {},
        open: {}
    }

    static enterInAlbum(album_id) {
        Gallery.albumId = album_id
        Timer.start('album_'+Gallery.albumId)
        Gallery._resetCache()
    }

    static _resetCache() {
        Gallery._cache = {
            view: {},
            open: {},
            banner: {},
            media: {},
        }
    }
    static exitAlbum() {
        const time = Timer.stop('album_'+Gallery.albumId)
        Message.timeInAlbum(Gallery.albumId, time)
        Gallery.albumId = null
        Gallery._resetCache()
    }

    static mediaViewed(photo_id, is_video = false) {
        if (Gallery._cache.view[photo_id]) return
        Gallery._cache.view[photo_id] = true
        Message.mediaViewed(photo_id, is_video)
    }

    static mediaOpened(photo_id, is_video = false) {
        if (Gallery._cache.open[photo_id]) return
        Gallery._cache.open[photo_id] = true
        Message.mediaOpened(photo_id, is_video)
    }

    static bannerViewed(banner_id) {
        if (Gallery._cache.banner[banner_id]) return
        Gallery._cache.banner[banner_id] = true
        Message.bannerViewed(banner_id)
    }

    static bannerClicked(banner_id) {
        Message.bannerClicked(banner_id)
    }
}
